import { render, staticRenderFns } from "./DefaultValueSwitchSelector.vue?vue&type=template&id=aec4e076&scoped=true&"
import script from "./DefaultValueSwitchSelector.vue?vue&type=script&lang=babel&"
export * from "./DefaultValueSwitchSelector.vue?vue&type=script&lang=babel&"
import style0 from "./DefaultValueSwitchSelector.vue?vue&type=style&index=0&id=aec4e076&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec4e076",
  null
  
)

export default component.exports